<template lang="pug">
  footer
    .flex.justify-between.items-center.max-w-4xl.mx-auto
      .flex.items-center
        .mr-4.whitespace-no-wrap
          span.hidden(class="lg:inline") マグロボ
          | 完成率
        .font-bebas.leading-none.whitespace-no-wrap
          span.text-5xl.-mb-2.inline-block.text-right.w-16 {{animatedCompletionRate}}
          span.ml-1 %
      .mx-4.flex-grow(class="hidden ls:block md:block")
        .indicator
          .indicator-base
          .indicator-light(:style="{width:animatedCompletionRate+'%'}")
      router-link(class="router-link-ghost lg:w-48" to="/status") MYマグロボを見る
</template>
<style lang="sass" scoped>
footer
  @apply fixed z-50 bottom-0 inset-x-0 px-4 pb-4 pt-8
  background: linear-gradient(to top, rgba(#000, 0.25), rgba(#000, 0))
  @screen md
    @apply pt-4
    background: rgba(#000, 0.5)
.indicator
  @apply relative
.indicator-base
  @apply h-1 rounded
  background-color: rgba(#000, 0.5)
  box-shadow: inset 0 1px 3px rgba(#000, 0.5)
.indicator-light
  @apply absolute inset-y-0 left-0 bg-bolt rounded
  box-shadow: theme("colors.bolt") 0 0 4px
</style>
<script>
import { mapGetters } from "vuex";
import { TweenMax } from "gsap";
export default {
  data() {
    return {
      tweenedCompletionRate: 0
    };
  },
  computed: {
    ...mapGetters("magrobo", ["completionRate", "status"]),
    animatedCompletionRate() {
      return this.tweenedCompletionRate.toFixed(0);
    }
  },
  mounted() {
    this.tweenCompletionRate(this.completionRate);
  },
  watch: {
    completionRate: function(newValue) {
      this.tweenCompletionRate(newValue);
    }
  },
  methods: {
    tweenCompletionRate(newValue) {
      TweenMax.to(this.$data, {
        duration: 0.5,
        tweenedCompletionRate: newValue
      });
    }
  }
};
</script>
